import {
    INCREMENT_CATEGORY,
    DECREMENT_CATEGORY,
    INCREMENT_BUNDLE_MEMBER,
    DECREMENT_BUNDLE_MEMBER,
    SET_PRICING_MODEL,
    // Legacy imports for backwards compatibility
    INCREMENT_ADULTS,
    DECREMENT_ADULTS,
    INCREMENT_INFANTS,
    INCREMENT_CHILDREN,
    INCREMENT_YOUTH,
    DECREMENT_INFANTS,
    DECREMENT_CHILDREN,
    DECREMENT_YOUTH,
} from "./types";

/**
 * Set the pricing model and initialize categories from backend
 * @param {Object} pricingModel - The pricing model from the train API response
 */
export const setPricingModel = (pricingModel) => (dispatch) => {
    dispatch({
        type: SET_PRICING_MODEL,
        payload: pricingModel,
    });
};

/**
 * Add a traveler to a category (new dynamic approach)
 * @param {string} category - The category key (e.g., 'adult', 'youth', 'child', 'infant')
 */
export const addTraveler = (category) => async (dispatch) => {
    try {
        dispatch({
            type: INCREMENT_CATEGORY,
            payload: category,
        });
    } catch (err) {
        console.log(err);
    }
};

/**
 * Remove a traveler from a category (new dynamic approach)
 * @param {string} category - The category key (e.g., 'adult', 'youth', 'child', 'infant')
 */
export const removeTraveler = (category) => async (dispatch) => {
    try {
        dispatch({
            type: DECREMENT_CATEGORY,
            payload: category,
        });
    } catch (err) {
        console.log(err);
    }
};

/**
 * Add one variable bundle member (e.g. a child in a family ticket).
 * @param {string} category - The bundle category key (e.g. 'family')
 * @param {string} type - The member category key to add (e.g. 'child')
 */
export const addBundleMember = (category, type) => (dispatch) => {
    dispatch({
        type: INCREMENT_BUNDLE_MEMBER,
        payload: { category, type },
    });
};

/**
 * Remove one variable bundle member (e.g. a child in a family ticket).
 * @param {string} category - The bundle category key (e.g. 'family')
 * @param {string} type - The member category key to remove (e.g. 'child')
 */
export const removeBundleMember = (category, type) => (dispatch) => {
    dispatch({
        type: DECREMENT_BUNDLE_MEMBER,
        payload: { category, type },
    });
};
